import { buildHttpHeaders } from "../../utils/buildHttpHeaders";
import { getAppSettings } from "../Utils/localStorageHelper";

const PATH = 'userInfo';

export async function getUserInformationAsync(backendHeader: string, signal?: AbortSignal) {

  try {
    const response = await fetch(PATH, {

      headers: buildHttpHeaders(backendHeader),
      signal: signal
    });

    if (response.status !== 200) {
      throw new Error(await response.text());
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.log(error);

    throw error;
  }
}

export async function getLoginFlowAsync(clientId: string) {

  const appSettings = getAppSettings();
  const response = await fetch(`${PATH}/getLoginFlow`, {
      headers: {
          'Backend': clientId,
          'HandymanApiUrl': appSettings.handymanApiUrl!
      }
  });

  if (response.ok) return response.text();

  if (response.status === 400) {
    throw new Error('INVALID_CLIENT');
  }

  throw new Error(await response.text());
}